import { FEATURE_TOGGLES } from 'constants/featureToggles';
import { IFeatureToggleModel } from '../reducers/featureToggle/models';

export const isFeatureEnabled = (featureToggles: IFeatureToggleModel[], requiredFeatures?: FEATURE_TOGGLES[]): boolean => {
    if (requiredFeatures === undefined) {
        return true;
    }
    return requiredFeatures.reduce((prev: boolean, requiredFeature: FEATURE_TOGGLES) => {
        return featureToggles && featureToggles.length !== 0 ? prev || !!featureToggles.find((featureToggle: IFeatureToggleModel) => featureToggle.state && featureToggle.featureName === requiredFeature) : false;
    }, false)
};